module.exports = __webpack_public_path__ + "img/MoonSword 1b.18a551ad.png";